import React from 'react';
import { MessageSquareDashedIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonials-title" className="bg-brand-alt px-4 py-20 md:py-28" data-id="element-185" data-mp="20qnnnpi6mhol">
      <Reveal className="mx-auto max-w-content" data-id="element-186" data-mp="1mzisp0predkl">
        <div className="mb-12 text-center" data-id="element-187" data-mp="1r143mgiqghs5">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal" data-id="element-188" data-mp="1r02skc1pvvaf">VOCI DALLE PALESTRE</p>
          <h2 id="testimonials-title" className="text-3xl font-extrabold tracking-tight text-brand-primary md:text-4xl" data-id="element-189" data-mp="1d3xoqx14r387">
            Cosa Dicono gli Insegnanti
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-3" data-id="element-190" data-mp="182i250jb0onp">
          {[0, 1, 2].map(slot => <article key={slot} className="flex min-h-[180px] flex-col items-center justify-center rounded-[18px] bg-brand-cream p-7 text-center" data-id="element-191" data-mp="2yf7h7winvkni">
              <span className="flex h-12 w-12 items-center justify-center rounded-[14px] border-2 border-dashed border-brand-gray/35" data-id="element-192" data-mp="32ega6z5vnei0">
                <MessageSquareDashedIcon className="h-6 w-6 text-brand-gray/60" strokeWidth={1.5} aria-hidden="true" data-id="element-193" data-mp="2q39hkcd5nxd0" />
              </span>
              <p className="mt-4 font-display text-lg font-semibold text-brand-gray" data-id="element-194" data-mp="34qm6mb268l85">Recensione in arrivo</p>
            </article>)}
        </div>
        <p className="mx-auto mt-8 max-w-2xl text-center text-xs leading-relaxed text-brand-gray" data-id="element-195" data-mp="2c26tju2loczg">
          Le testimonianze verranno pubblicate appena raccolte da insegnanti che hanno provato EDUCAZIONE FISICA
          PRONTA™.
        </p>
      </Reveal>
    </section>;
}